import type { VerifyEmailRequestDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";

export function useVerifyEmail() {
	return useApiMutation(
		"post",
		"/auth/verify-email",
		{
			notify: false,
			mapVariables: (data: VerifyEmailRequestDto) => ({
				body: data,
				headers: {
					"x-auth-request": "true",
				},
			}),
		},
	);
}
